/*
 *   Copyright (c) 2021 RCUBE PLANET PVT LTD
 *   All rights reserved.
 */
import React, { useContext } from "react";
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import * as Icon from "react-feather";
import { history } from "../../../history";
import Avatar from "../../../components/@vuexy/avatar/AvatarComponent";

import { AuthContext } from "../../../auth/Auth";
const UserDropdown = () => {
  let context = useContext(AuthContext);
  return (
    <DropdownMenu right>
      <DropdownItem
        tag="a"
        href="#"
        onClick={() => history.push(`/edit-staff?id=${context.user?.id}`)}
      >
        <Icon.User size={14} className="mr-50" />
        <span className="align-middle">Edit Profile</span>
      </DropdownItem>
      <DropdownItem tag="a" href="#" onClick={context.logout}>
        <Icon.Power size={14} className="mr-50" />
        <span className="align-middle">Log Out</span>
      </DropdownItem>
    </DropdownMenu>
  );
};

const NavbarUser: React.FC<any> = (props) => {
  let context = useContext(AuthContext);

  const name = context.user?.name || "";
  const getAvatarContent = () => {
    return (
      name
        ?.split(" ")
        ?.map((a: string) => a.charAt(0))
        ?.join("")
        .toUpperCase() || ""
    );
  };

  return (
    <ul className="nav navbar-nav navbar-nav-user float-right">
      <UncontrolledDropdown tag="li" className="dropdown-notification nav-item">
        {/* <DropdownToggle tag="a" className="nav-link nav-link-label">
          <Icon.Bell size={21} />
          <Badge pill color="primary" className="badge-up">
            {context.unreadNotification}
          </Badge>
        </DropdownToggle> */}
        <DropdownMenu tag="ul" right className="dropdown-menu-media">
          <li className="dropdown-menu-header">
            <div className="dropdown-header mt-0">
              <h3 className="text-white">{context.unreadNotification} New</h3>
              <span className="notification-title">App Notifications</span>
            </div>
          </li>

          <li className="dropdown-menu-footer">
            <DropdownItem tag="a" className="p-1 text-center">
              <span className="align-middle">Read all notifications</span>
            </DropdownItem>
          </li>
        </DropdownMenu>
      </UncontrolledDropdown>
      <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
        <DropdownToggle tag="a" className="nav-link dropdown-user-link">
          <div className="user-nav d-sm-flex d-none">
            <span className="user-name text-bold-600">{name}</span>
            <span className="user-status">Available</span>
          </div>
          <span data-tour="user">
            {/* <img src={this.props.userImg} className="round" height="40" width="40" alt="avatar" /> */}
            <Avatar
              color="success"
              className="mr-1"
              content={getAvatarContent()}
            />
          </span>
        </DropdownToggle>
        <UserDropdown {...props} />
      </UncontrolledDropdown>
    </ul>
  );
};
export default NavbarUser;
